import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import {countries, devConfig, profile} from 'config/config'; // Importing configuration settings
import { providersCasino } from 'config/config'; // Importing casino providers configuration
import { gamesCasino } from 'config/config'; // Importing casino games configuration

/**
 * Class representing the FilterPlayerPrizesLoyaltyView.
 * @extends JetView
 */
export default class FilterPlayerPrizesLoyaltyView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date range
                            name: 'activationDate',
                            id: 'activationDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Activación'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date range
                            name: 'redemptionDate',
                            id: 'redemptionDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Redención'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date range
                            name: 'expirationDate',
                            id: 'expirationDate',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Expiración'), // Translated label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'richselect',
                            name: 'state',
                            id: 'state',
                            label: "<span class='icon-state'></span>" + _('Estado del Giro'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'P', value: _('Pendiente') }, // Option for all
                                { id: 'PR', value: _('Pendiente Rollback') }, // Option for activated
                                { id: 'PP', value: _('Pendiente Procesar') }, // Option for activated
                                { id: 'A', value: _('Activa') }, // Option for deactivated
                                { id: 'R', value: _('Redimido') }, // Option for deactivated
                                { id: 'E', value: _('Expirado') }, // Option for deactivated
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'rouletteId',
                            id: 'rouletteId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Ruleta'),
                            labelPosition: 'top',
                            placeholder: _('ID Ruleta'),
                            invalidMessage: _('Roulette ID is required'),
                        },
                        {
                            view: 'text',
                            name: 'rouletteName',
                            id: 'rouletteName',
                            label: "<span class='icon-user'></span>" + _('Nombre de Ruleta'),
                            labelPosition: 'top',
                            placeholder: _('Nombre de Ruleta'),
                            invalidMessage: _('Roulette Name is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'typeAward',
                            id: 'typeAward',
                            label: "<span class='icon-gift'></span>" + _('Tipo de Premio'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'freebet', value: _('Freebet') }, // Option for all
                                { id: 'freespin', value: _('Freespin') }, // Option for activated
                                { id: 'bonus', value: _('Bono') }, // Option for activated
                                { id: 'cash', value: _('Dinero') }, // Option for deactivated
                                { id: 'physical_award', value: _('Premio Físico') }, // Option for deactivated
                                { id: 'extra_spin', value: _('Giro Extra') }, // Option for deactivated
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: 140,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'),
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('playerRouletteReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to submit the second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to submit
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('playerPrizesLoyaltyReport:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filter sections
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the filter popup
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section in the scroll view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('activationDate').attachEvent('onAfterRender', () => {
            devConfig.setDateModal(lang);
        });
        $$('redemptionDate').attachEvent('onAfterRender', () => {
            devConfig.setDateModal(lang);
        });
        $$('expirationDate').attachEvent('onAfterRender', () => {
            devConfig.setDateModal(lang);
        });
    }
}

// FILE DOCUMENTED
